<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <h2>rest/api/municipio</h2>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a href="index.html">Home</a>
      </li>
      <li class="breadcrumb-item">
        <a>APM Inscrições</a>
      </li>
      <li class="breadcrumb-item active">
        <strong>Teste Angular e API Laravel</strong>
      </li>
    </ol>
  </div>
  <div class="col-lg-2"></div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <h5>{{ municipios }}</h5>
        </div>
        
      </div>
    </div>
  </div>
  </div>
